import React, {useEffect} from 'react';
import { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Col, Container, Row } from 'reactstrap';
import MapControls from './MapControls';
import MapZoomButtons from './MapZoomButtons';
import StopList from './StopList';
import UnitMap from './UnitMap';
import { useFetch } from '../../../hooks/useFetch';
import { getTourDetails } from '../../../api/MyTours';
import moment from 'moment-timezone';
// import IconButton from '../../common/form/IconButton';
// import AccessIcon from '../../../images/access_icon.png';
import TourAccessPopup from '../../pages/prospect/tour/applessTour/TourAccessPopup';

const UnitMapWrapper = () => {
    const MinutesBeforeTourStart = 15;
    const [accessWindowIsActive, setAccessWindowIsActive] = useState(false);
    const [tourAccessPopupIsOpen, setTourAccessPopupIsOpen] = useState(false);

    let apiKey = process.env.REACT_APP_UNITMAP_API_KEY;
    const [tourStopsOpen, setTourStopsOpen] = useState(true);
    const [legendOpen, setLegendOpen] = useState(false);
    const handleTourStopClick = () => {
        setTourStopsOpen(!tourStopsOpen);
        if (isMobile) {
            setLegendOpen(false);
        }
    };
    const handleLegendClick = () => {
        setLegendOpen(!legendOpen);
        if (isMobile) {
            setTourStopsOpen(false);
        }
    };
    const tourGuid:string = sessionStorage.getItem('tourGuid')!;
    const {
        data: tourAccessData,
    } = useFetch(() => getTourDetails(tourGuid), [], undefined);

    const handleAccessClick = () => {
        setTourAccessPopupIsOpen(true);
        return;
    };

    const checkAccessTime = () => {
        if (!tourAccessData || !tourAccessData.tourStart) {
            return;
        }
        let currentTime = moment(new Date());

        let accessStart = moment
            .utc(tourAccessData.tourStart)
            .subtract(MinutesBeforeTourStart, 'minutes');
        let accessEnd = moment.utc(tourAccessData.tourEnd);
        //Adding Z to time strings to properly format as UTC time
        if (currentTime < accessStart || currentTime > accessEnd) {
            setAccessWindowIsActive(false);
            return;
        }
        setAccessWindowIsActive(true);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            checkAccessTime();
        }, 10000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        checkAccessTime();
    }, [tourAccessData]);
    return (
        <Container fluid={true}>
            {isMobile && (
                <Row fluid={'md'} className="justify-content-center">
                    <MapControls
                        tourStopsOpen={tourStopsOpen}
                        legendOpen={legendOpen}
                        handleTourStopClick={handleTourStopClick}
                        handleLegendClick={handleLegendClick}
                    />
                </Row>
            )}
            <Row fluid={'md'}>
                {!isMobile && (
                    <Col xl={3} className="justify-content-center">
                        <Row className="justify-content-center">
                            <MapControls
                                tourStopsOpen={tourStopsOpen}
                                legendOpen={legendOpen}
                                handleTourStopClick={handleTourStopClick}
                                handleLegendClick={handleLegendClick}
                            />
                        </Row>
                        <Row>
                            <Col className="justify-center-center desktop-tour-stops-new" align="center">
                                <StopList title={'Tour Stops'} />
                            </Col>
                        </Row>
                        <Row>
                        {accessWindowIsActive && (
                            <Col className="justify-content-center" align="center">        
                                <div 
                                    className="unit-map-access-code-btn"
                                    onClick={handleAccessClick}
                                >
                                    <i className="fa-solid fa-door-open"/> Unit Access Codes
                                </div>                                
                                {tourAccessData &&
                                    <TourAccessPopup
                                        isOpen={tourAccessPopupIsOpen && accessWindowIsActive}
                                        close={() => setTourAccessPopupIsOpen(false)}
                                        accessInfo={tourAccessData}                                
                                    />
                                }
                            </Col>
                            )}
                        </Row>
                    </Col>
                )}
                <Col>{apiKey ? <UnitMap apiKey={apiKey} /> : <h2>No API Key configured</h2>}</Col>
            </Row>
            <Row fluid={'md'}>
                <Col className={'centered-col'}>
                    <MapZoomButtons />
                </Col>
            </Row>
        </Container>
    );
};

export default UnitMapWrapper;



// WEBPACK FOOTER //
// ./src/components/common/UnitMap/UnitMapWrapper.tsx